import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createContext } from 'react';
export const defaultQueryClient = new QueryClient();
export const queryContext = createContext(undefined);
export const Web3WalletQueryClientProvider = ({ children, queryClient, }) => {
    return (_jsx(QueryClientProvider, { client: queryClient ?? defaultQueryClient, context: queryContext, children: children }));
};
